'use client';

import React, { useEffect, useRef, useState } from 'react';
import { Tab, TabGroup, TabList, TabPanel, TabPanels, Transition } from '@headlessui/react';
export type TabsProps = {
  tabTitles: Array<string>;
  tabContents: Array<React.JSX.Element>;
  className?: string;
  testId?: string;
};
function Tabs({
  tabTitles,
  tabContents,
  className,
  testId
}: TabsProps): React.JSX.Element {
  const [tabIndex, setTabIndex] = useState(0);
  const tabsRef = useRef<Array<HTMLElement | null>>([]);
  const [underlineLeft, setUnderlineLeft] = useState(0);
  const [underlineWidth, setUnderlineWidth] = useState(0);
  useEffect(() => {
    function setTabPosition() {
      const totalTabs = tabTitles.length;
      const percentage = tabIndex / totalTabs * 100;
      const currentTab = tabsRef.current[tabIndex];
      setUnderlineLeft(percentage);
      setUnderlineWidth(currentTab?.clientWidth ?? 0);
    }
    setTabPosition();
    window.addEventListener('resize', setTabPosition);
    return () => window.removeEventListener('resize', setTabPosition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabIndex]);
  return <TabGroup as="div" selectedIndex={tabIndex} onChange={setTabIndex} className={className} data-testid={testId}>
      <TabList className="w-full flex flex-row relative border-b-4 border-gray-100">
        {tabTitles.map((tab, idx) => <Tab className="ui-selected:font-semibold text-black-900 block flex-1 text-left pl-6 pb-3 pt-2" key={idx}
      // @ts-ignore
      ref={el => tabsRef.current[idx] = el}>
            {tab}
          </Tab>)}
        <div className="absolute -bottom-1 h-1 bg-primary-900 transition-all duration-250" style={{
        left: `${underlineLeft}%`,
        width: `${underlineWidth}px`
      }} />
      </TabList>
      <TabPanels className="mt-12">
        {tabContents.map((item, index) => <TabPanel key={index}>
            <Transition as="div" appear show={tabIndex == index} enter="transition-opacity duration-500" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity duration-500" leaveFrom="opacity-100" leaveTo="opacity-0">
              {item}
            </Transition>
          </TabPanel>)}
      </TabPanels>
    </TabGroup>;
}
export default Tabs;